(function (Drupal, $) {
  Drupal.behaviors.updates = {
    attach: function (context) {
      $(function() {
        $('.resources__wrapper').once().each(function(){
          var download = $(this).find('.resources__link .file a');
          $(this).find('.resources__download').append(download.clone().attr('download',''));
        })

        if ($("html[dir='rtl']").length && $("main.main-content__wrapper[lang='ar']").length) {
          $(".view-listing-updates .updates-item__date").once().each(function () {
            var text = $(this).text();
            $(this).text(text.split('/').reverse().join('/'));
          });
        }
        
        $(".view-listing-updates .updates-item__date").show();
      });      
    }
  }
})(Drupal, jQuery);